// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2bNwB","header":"PatientBlock_header__1SWP5","label":"PatientBlock_label__2ErV3","option":"PatientBlock_option__1HVpj"};